import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import './assets/styles/main.scss';
import './assets/styles/safe-area.scss';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { Capacitor } from '@capacitor/core'
import { App as CapacitorApp } from '@capacitor/app'
import { initGoogleAuth } from '@/plugins/googleAuth'


// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

library.add(faChevronLeft, faChevronRight);

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(ElementPlus);
app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app');

// 原生 Android 启动时初始化 Google Auth（提前准备登录）
if (Capacitor.getPlatform() === 'android') {
	initGoogleAuth()

	// 处理原生返回键：优先返回上一页，没有上一页时才退出 App
	CapacitorApp.addListener('backButton', ({ canGoBack }) => {
		const routerState = router.options.history.state as { back?: string | null; position?: number } | null;
		const historyPosition = routerState?.position ?? 0;
		const hasRouterHistory = Boolean(routerState && routerState.back !== null && historyPosition > 0);
		const shouldNavigateBack = canGoBack || hasRouterHistory;
		const currentRoute = router.currentRoute.value;
		const isAtRootRoute = currentRoute?.name === 'home' || currentRoute?.path === '/';

		if (shouldNavigateBack) {
			router.back();
			return;
		}

		if (isAtRootRoute) {
			CapacitorApp.exitApp();
		} else {
			router.push('/');
		}
	});
}
